/* eslint-disable react/prop-types */
import * as React from 'react';
import { styled } from '@mui/material/styles';
import { getValidPrice } from '@/utils';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';

import classes from './ReimbursedItem.module.css';

const arrowIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAAGFBMVEUAAABbX2JgYGBbXmJcX2JdX2RcXmJcX2KfxFtqAAAAB3RSTlMA3xDQn49/elZ9XQAAACZJREFUCNdjoDpQFIIzzYsVoCyW8nIHKDO9vLwUyhQvLy9koB0AAEyQBXDZ2UREAAAAAElFTkSuQmCC';

const PolicyAccordion = styled(
  // eslint-disable-next-line react/jsx-props-no-spreading
  (props) => <Accordion disableGutters elevation={0} {...props} />,
)(() => ({
  border: 'none',
  boxShadow: 'none',
  margin: 0,
  padding: 0,
}));

const PolicyAccordionSummary = styled(
  // eslint-disable-next-line react/jsx-props-no-spreading
  (props) => <AccordionSummary {...props} />,
)(() => ({
  padding: 0,
  margin: 0,

  '& .MuiAccordionSummary-content': {
    marginBottom: '9PX',
    marginTop: '20PX',
  },
}));

const PolicyAccordionDetail = styled(
  // eslint-disable-next-line react/jsx-props-no-spreading
  (props) => <AccordionDetails {...props} />,
)(() => ({
  padding: 0,
}));

export const ReimbursedItem = React.memo(({ claimItem }) => {
  const [expanded, setExpended] = React.useState(false);

  const { reimbursementItem } = claimItem || {};
  if (!reimbursementItem) {
    return null;
  }

  const { itemName = '', itemPrice = '' } = reimbursementItem || {};
  const price = getValidPrice(itemPrice);

  const handleChange = () => {
    setExpended(!expanded);
  };

  return (
    <div>
      <PolicyAccordion expanded={expanded} onChange={handleChange} defaultExpanded={false}>
        <PolicyAccordionSummary>
          <div className={classes.accordionSummary}>
            <section className={classes.summaryTitle}>
              Reimbursement for refund
              <img src={arrowIcon} alt="" className={`${classes.accordionArrow} ${expanded ? '' : classes.reversedArrow}`} />
            </section>
            <section>{`+$${price}`}</section>
          </div>
        </PolicyAccordionSummary>
        <PolicyAccordionDetail>
          <div className={classes.accordionDetail}>
            <section className={classes.accordionItemName}>{itemName}</section>
            <section className={classes.accordionItemPrice}>{`$${price}`}</section>
          </div>
        </PolicyAccordionDetail>
      </PolicyAccordion>
    </div>
  );
});
